import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditRoadtripModal = ({ show, handleClose, roadtrip, onSave }) => {
    const [formData, setFormData] = useState({
        roadtrip_name: roadtrip.roadtrip_name,
        description: roadtrip.description || '',
        roadtrip_status: roadtrip.roadtrip_status,
        date_depart_prevu: roadtrip.date_depart_prevu || '',
        date_fin_prevu: roadtrip.date_fin_prevu || '',
        lieux: roadtrip.lieux || '',
        lien_externe: roadtrip.lien_externe || '',
        infos_supplementaire: roadtrip.infos_supplementaire || ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Modifier le roadtrip</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Nom du roadtrip</Form.Label>
                        <Form.Control
                            type="text"
                            name="roadtrip_name"
                            value={formData.roadtrip_name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows={3}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Statut</Form.Label>
                        <Form.Select
                            name="roadtrip_status"
                            value={formData.roadtrip_status}
                            onChange={handleChange}
                        >
                            <option value="0">Brouillon</option>
                            <option value="1">Terminé</option>
                            <option value="2">À venir</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Date de départ</Form.Label>
                        <Form.Control
                            type="date"
                            name="date_depart_prevu"
                            value={formData.date_depart_prevu}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Date de fin</Form.Label>
                        <Form.Control
                            type="date"
                            name="date_fin_prevu"
                            value={formData.date_fin_prevu}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Lieux</Form.Label>
                        <Form.Control
                            type="text"
                            name="lieux"
                            value={formData.lieux}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Lien externe</Form.Label>
                        <Form.Control
                            type="text"
                            name="lien_externe"
                            value={formData.lien_externe}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Informations supplémentaires</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="infos_supplementaire"
                            value={formData.infos_supplementaire}
                            onChange={handleChange}
                            rows={3}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditRoadtripModal;